import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { ABOUT } from "@/lib/site";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative bg-white py-24 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-5"
          >
            <p className="font-sans text-xs font-bold uppercase tracking-[0.2em] text-zi-accent">
              {ABOUT.overline}
            </p>
            <h2 className="mt-4 font-heading text-4xl font-bold tracking-tight text-zi-ink sm:text-5xl">
              {ABOUT.title}
            </h2>
            <div className="mt-8 space-y-3">
              {ABOUT.highlights.map((h) => (
                <div key={h} className="flex items-center gap-3">
                  <span className="flex h-6 w-6 flex-none items-center justify-center rounded-full bg-zi-primary text-white">
                    <Check size={14} strokeWidth={3} />
                  </span>
                  <span className="font-heading text-base font-semibold text-zi-ink">{h}</span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="space-y-5 lg:col-span-7"
          >
            {ABOUT.paragraphs.map((p, i) => (
              <p key={i} className="font-sans text-lg leading-relaxed text-zi-muted">
                {p}
              </p>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
